import { TagComponent } from "ecsy";

export class Play extends TagComponent {}
